function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m36.171 0.62015c7.5468 0 13.668 6.1433 13.668 13.701 0 0.9501-0.09717 1.8786-0.28071 2.7639l-0.20514 0.79895 0.52903 0.47505c1.8138 1.8246 2.9367 4.3294 2.9367 7.1042 0 5.2148-3.9408 9.4902-9.0044 10.008l-0.71258 0.03239v0.0108h-29.367v-0.0108l-0.6154-0.03239c-4.2862-0.43186-7.6332-4.0595-7.6332-8.4753 0-4.6965 3.8112-8.5185 8.5077-8.5185l0.12956 0.0108v-0.02159c1.1013-3.5305 4.3942-6.1001 8.281-6.1001l0.23752 0.02159 0.12956-0.82054c1.274-6.2512 6.7911-10.948 13.399-10.948z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m35.968 0.62015c7.484 0 13.555 6.1433 13.555 13.701 0 0.9501-0.09636 1.8786-0.27837 2.7639l-0.20343 0.79895 0.52463 0.47505c1.7987 1.8246 2.9122 4.3294 2.9122 7.1042 0 5.2148-3.908 9.4902-8.9294 10.008l-0.70664 0.03239v0.0108h-0.3105v0h-28.555v0h-0.25696v-0.0108l-0.61028-0.03239c-4.2506-0.43186-7.5697-4.0595-7.5697-8.4753 0-4.6965 3.7795-8.5185 8.4369-8.5185l0.12848 0.0108v-0.02159c1.0921-3.5305 4.3576-6.1001 8.2121-6.1001l0.23555 0.02159 0.12848-0.82054c1.2634-6.2512 6.7345-10.948 13.287-10.948z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.79666
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m40.021 18.686h-3.4946l4.9832 7.2742 5.0782-7.3798h-3.6952c-1.7314-7.8549-9.9769-9.808-15.045-6.5879-1.8898 1.457 0.13725 3.3468 1.5203 2.3227 2.8822-1.9426 9.1429-1.4569 10.653 4.3708z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-primary",
  d: "m25.973 23.379h3.5172l-5.0155-7.3319-5.1217 7.4382h3.7297c1.732 7.9057 10.042 9.8715 15.142 6.6306 1.9021-1.4664-0.13814-3.3684-1.5301-2.3377-2.9009 1.9552-9.2021 1.4664-10.722-4.3992z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m40.021 18.686h-3.4946l4.9832 7.2742 5.0782-7.3798h-3.6952c-1.7314-7.8549-9.9769-9.808-15.045-6.5879-1.8898 1.457 0.13725 3.3468 1.5203 2.3227 2.8822-1.9426 9.1429-1.4569 10.653 4.3708z",
  strokeWidth: 0.78229
}), React.createElement("path", {
  d: "m25.973 23.379h3.5172l-5.0155-7.3319-5.1217 7.4382h3.7297c1.732 7.9057 10.042 9.8715 15.142 6.6306 1.9021-1.4664-0.13814-3.3684-1.5301-2.3377-2.9009 1.9552-9.2021 1.4664-10.722-4.3992z",
  strokeWidth: 0.78736
}));
var SvgMenuSysadminLicense = function SvgMenuSysadminLicense(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuSysadminLicense, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-Sysadmin-License.c41bc184.svg";
export { ForwardRef as ReactComponent };